// ======================================================================
// File Name       : MessageTemplate
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, FormControl, Col, Button, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { TOP_LIST } from './PathConstants';
import IconInformation from '../images/icon-information.svg';
import IconWarning from '../images/icon-warning.svg';

export const BULK_EXPORT = (
  <div>
    <p>出力する件数が多い場合、</p>
    <p style={{ marginTop: '10px' }}>ファイルの出力に数分かかることがあります。</p>
    <p style={{ marginTop: '20px' }}>一括出力を実施しますか？</p>
  </div>
);

export const BULK_EXPORT_USER_HISTORY = (
  <div>
    <p>CSVファイルへ出力できる上限は1,000,000件となります。</p>
    <p style={{ marginTop: '10px' }}>上限を超える場合は検索条件を設定し直して、</p>
    <p style={{ marginTop: '10px' }}>再度CSV出力を実施してください。</p>
  </div>
);

export const BULK_DOWNLOAD = (
  <div>
    <p>ダウンロードを開始しますが</p>
    <p style={{ marginTop: '10px' }}>よろしいですか？</p>
  </div>
);

export const BULK_UPLOAD = (
  <div>
    <p>アップロードを開始しますが</p>
    <p style={{ marginTop: '10px' }}>よろしいですか？</p>
  </div>
);

export const COLLECTIVE_REFLECTION = (
  <div>
    <p>データの件数が多い場合、</p>
    <p style={{ marginTop: '10px' }}>処理に数分かかることがあります。</p>
    <p style={{ marginTop: '20px' }}>一括反映を実施しますか？</p>
    {/* #6829 START */}
    <p style={{ marginTop: '30px' }}>※難易度・識別度の反映対象は、ドリルと問題です。</p>
    <p style={{ marginTop: '10px' }}>反映結果はマスタ／メタデータを一括出力してご確認ください。</p>
    {/* #6829 END */}
  </div>
);

export const BULK_IMPORT = (
  <div>
    <p>一括編集を開始しますが</p>
    <p>よろしいですか？</p>
  </div>
);

export const MSG_OK = (
  <div>
    <p>以下の内容で登録／編集しますが</p>
    <p>よろしいですか？</p>
    <p>公開ステータス：公開</p>
  </div>
);

export const MSG_DEL_MESSAGE_THREAD = (
  <div>
    <p>対象のメッセージを削除しますが</p>
    <p>よろしいですか？</p>
  </div>
);


export const MSG_DEL_ENTERPRISE = (
  <div>
    <p>対象の企業を削除しますが</p>
    <p>よろしいですか？</p>
  </div>
);
export const MSG_DEL_ENTERPRISE_NOTICE = (
  <div>
    <p>対象の企業向けお知らせを削除しますが</p>
    <p>よろしいですか？</p>
  </div>
);

export const MSG_DEL_NOTIFICATION = (
  <div>
    <p>対象の通知メッセージを削除しますが</p>
    <p>よろしいですか？</p>
  </div>
);

export const MSG_DEL_SERVICE_NOTICE = (
  <div>
    <p>対象のサービス向けお知らせを削除しますが</p>
    <p>よろしいですか？</p>
  </div>
);


export const MSG_DEL_SERVICE = (
  <div>
    <p>対象のサービスを削除しますが</p>
    <p>よろしいですか？</p>
  </div>
);

export const MSG_DEL_DISTRIBUTION = (
  <div>
    <p>コンテンツ配布先サービスを削除しますが</p>
    <p>よろしいですか？</p>
  </div>
);


export const MSG_DEL_SKIN = (
  <div>
    <p>対象のスキンを削除しますが</p>
    <p>よろしいですか？</p>
  </div>
);

export const MSG_DEL_QUESTION = (
  <div>
    <p>対象の問題を削除しますが</p>
    <p>よろしいですか？</p>
  </div>
);

export const MSG_DEL_DRILL = (
  <div>
    <p>対象のドリルを削除しますが</p>
    <p>よろしいですか？</p>
  </div>
);

export const MSG_DEL_VIDEO = (
  <div>
    <p>対象のビデオを削除しますが</p>
    <p>よろしいですか？</p>
  </div>
);

export const MSG_DEL_DOC = (
  <div>
    <p>対象のドキュメントを削除しますが</p>
    <p>よろしいですか？</p>
  </div>
);

export const MSG_DEL_LINK = (
  <div>
    <p>対象のリンクを削除しますが</p>
    <p>よろしいですか？</p>
  </div>
);

export const MSG_DEL_GROUP = (
  <div>
    <p>対象のユーザーグループを削除しますが</p>
    <p>よろしいですか？</p>
  </div>
);

export const MSG_DEL_USER = (
  <div>
    <p>対象のユーザーを削除しますが</p>
    <p>よろしいですか？</p>
  </div>
);

export const MSG_DEL_AUTHORITY = (
  <div>
    <p>対象のロールを削除しますが</p>
    <p>よろしいですか？</p>
  </div>
);

export const MSG_DEL_SUPER_USER = (
  <div>
    <p>対象のSuper Userを削除しますが</p>
    <p>よろしいですか？</p>
  </div>
);

export const MSG_DEL_LIVE = (
  <div>
    <p>対象のライブを削除しますが</p>
    <p>よろしいですか？</p>
  </div>
);


export const DISTRIBUTE_REPORT = (
  <div>
    <p>レポートを分配して</p>
    <p>よろしいですか？</p>
  </div>
);
export const ACQUISITION_REPORT = (
  <div>
    <p>レポートを取得して</p>
    <p>よろしいですか？</p>
  </div>
);
export const RECOVER_REPORT = (
  <div>
    <p>レポートを強制回収して</p>
    <p>よろしいですか？</p>
  </div>
);

export const BULK_APPROVAL = (
  <div>
    <p>全○件のレポートを</p>
    <p>一括承認して</p>
    <p>よろしいですか？</p>
  </div>
);

export const CONFIRM_APPROVAL = (
  <div>
    <p>レポートを承認して</p>
    <p>よろしいですか？</p>
  </div>
);

export const CONFIRM_REPLY_REPORT = (
  <div>
    <p>レポートを差し戻して</p>
    <p>よろしいですか？</p>
  </div>
);
export const RETURN_REASON = (
  <div>
    <p>差し戻し理由</p>
  </div>
);
export const ENTER_RETURN_REASON = (
  <div>
    <p>差し戻し理由を</p>
    <p>入力してください</p>
  </div>
);
export const DISTRIBUTE_REPORT_COMPLETE = (
  <div>
    <p>対象のレポートが添削者によって取得されていた場合、</p>
    <p>割り当てレポート件数に差分が生じる可能性があります</p>
  </div>
);
export const MSG_UPLOAD = (
  <div>
    <p>一括投入を開始しますが</p>
    <p>よろしいですか？</p>
  </div>
);

export const WITHDRAW_REPORT = (
  <div>
    <p>レポートの承認依頼を</p>
    <p>取り下げてよろしいですか？</p>
  </div>
);

export const ACCOUNT_CHANGE_CONFIRM = (
  <div>
    <p>アカウント情報を変更しますがよろしいですか？</p>
  </div>
);

export const MSG_CONFIRM_UPDATE = (
  <div>
    <p>以下の内容で登録／編集しますが</p>
    <p>よろしいですか？</p>
  </div>
);

export const ADAPTIVE_DISCRIMINATION_DEGREE_DATA = '難易度・識別度の反映を行いました'; // #6829

export const MSG_DEL_EMAIL = (
  <div>
    <p>対象の予約メールを削除しますが</p>
    <p>よろしいですか？</p>
  </div>
);

export const MSG_PASSWORD_SATISFIED = 'パスワード強度が満たされています';
export const MSG_PASSWORD_NOT_SATISFIED = 'パスワード強度が満たされています';
export const MSG_URL_VALID = '';
export const MSG_URL_INVALID = 'URLのフォーマットが違います';
export const MSG_EMAIL_VALID = '';
export const MSG_EMAIL_INVALID = 'メールのフォーマットが違います';
export const MSG_ID_VALID = '';
export const MSG_ID_INVALID = 'IDのフォーマットが違います';
export const MSG_ID_INCLUDING_HYPHEN_VALID = '';
export const MSG_ID_INCLUDING_HYPHEN_INVALID = '{0}は半角英数字および-_のみ入力可能です';
export const MSG_NUMERIC_VALID = '';
export const MSG_NUMERIC_INVALID = '{0}は数字のみを入力してください';
export const MSG_NUMERIC_INVALID_WITHOUT_ZERO = '{0}は1以上の数字を入力して下さい';
export const MSG_INVOICE_NUMBER_VALID = '';
export const MSG_INVOICE_NUMBER_INVALID = '汎用請求番号のフォーマットが違います';
export const MSG_REAL_NUMBER_VALID = '';
export const MSG_REAL_NUMBER_INVALID = '実数のみを入力して下さい';
export const MSG_COURSE_BOX_ID_VALID = '';
export const MSG_COURSE_BOX_ID_INVALID = 'コース・セクション識別IDのフォーマットが違います';
export const MSG_DRILL_QUESTION_SETTING_VALID = '';
export const MSG_DRILL_QUESTION_SETTING_INVALID = '問題の設定のフォーマットが違います';
export const MSG_PASSWORD_STRONG = 'パスワード強度：強';
export const MSG_PASSWORD_MEDIUM = 'パスワード強度：中';
export const MSG_PASSWORD_WEAK = 'パスワード強度：標準';
export const MSG_PASSWORD_INVALID = 'パスワード強度が不足しているか、利用できない文字が含まれています【パスワード強度設定：{0}】';
export const MSG_PASSWORD_CONFIRM_MATCH = 'パスワードとパスワード(確認)が一致しています';
export const MSG_PASSWORD_CONFIRM_NOT_MATCH = 'パスワードとパスワード(確認)が一致しません';
export const MSG_LOGIN_INCORRECT = 'サービスコード、ログインID又はパスワードが正しくありません';
export const MSG_SERVICE_NOT_SELECT = 'サービス未選択';
export const MSG_GROUP_EXIST = 'ユーザーグループが重複しています';
export const MSG_OVERLAP = '{0}が重複しないように設定してください。';
export const MSG_VIDEO_UPLOAD_SIZE_VALID = '';
export const MSG_VIDEO_UPLOAD_SIZE_INVALID = 'アップロードするファイルサイズの上限を超えています（上限：10GB)'; // #6739
export const MSG_CONFIG_FILE_UPLOAD_SIZE_INVALID = 'アップロードするファイルサイズの上限を超えています（上限：2GB)';
export const MSG_DOCUMENT_UPLOAD_SIZE_VALID = '';
export const MSG_DOCUMENT_UPLOAD_SIZE_INVALID = 'アップロードするファイルサイズの上限を超えています（上限：200MB）';
export const MSG_THUMBNAIL_UPLOAD_SIZE_INVALID = 'アップロードするファイルサイズの上限を超えています（上限：5MB）';
export const MSG_UPLOAD_MIN_SIZE_INVALID = 'ファイルサイズが小さすぎます';
export const MSG_EXPORT_CSV_SUCCESS = (
  <span>
    処理結果については、完了後にトップの
    <Link to={TOP_LIST} style={{ fontWeight: 'bold', textDecoration: 'underline' }}>
      システムお知らせ一覧
    </Link>
    に表示されますので、そのお知らせの詳細から結果をダウンロードしてください
  </span>
);
export const MSG_PASSWORD_VALID = 'パスワード強度が満たされています';
export const MSG_QUESTION_ANSWER = '正解の番号が連番になっていません';
export const MSG_MIN_ANSWER_LIST = '選択肢は2個以上入力して下さい';
export const MSG_QUESTION_SELECTIVE_SINGLE_ANSWER = '選択式単一解答の場合には、正解は1つしか設定できません';

export const MSG_ITEM_LIST_FOR_COURSE_END_INVALID = 'アイテムが紐付けされていないため、コース完了条件を設定できません';
export const MSG_ITEM_LIST_FOR_BOX_END_INVALID = 'アイテムが紐付けされていないため、セクション完了条件を設定できません';
export const MSG_FILE_TYPE_INVALID = '指定されたファイルの種類が不正です';
export const MSG_FILE_TYPE_INVALID_NOT_ACCEPT = '指定されたファイルを添付することはできません';
export const MSG_MAX_MINUTE = '予約時間は{0}分を超えないように設定してください';
export const MSG_LIMIT_ARRAY = '{0}の上限を超えています';
export const MSG_SAME_DAY = '開始日時と終了日時は同じ日で設定して下さい';

export const W_REQUIRED = '{0}が入力されていません';
export const W_VALUE_INVALID = '{0}に入力できない文字が含まれています';
export const W_PATTERN_INCORRECT = '{0}のフォーマットが違います';
export const W_IS_NOT_NUMERIC = '{0}は数字のみを入力してください';
export const W_MAX_LENGTH = '{0}の文字数が最大文字数を超過しています';
export const W_FILE_EXTENSION_INCORRECT = 'ファイル「{0}」の形式が違います';
export const W_SEARCH_RESULT_NOT_FOUND = '該当する検索結果はありません';
export const W_SERVICE_NOT_FOUND = '該当するサービスは存在しません';
export const W_MAX_NUMBER = '{0}は{1}を超えないように設定してください';
export const W__MIN_MAX_NUMBER = '{0}は{1}から{2}までの値を入力してください';
// #7372 START
export const W_MIN_MAX_NUMBER_WITHOUT_LABEL = '{0}～{1}の間で入力してください';
// #7372 END
// Step 11.0.0 START
export const W_MIN_NUMBER = '{0}文字以上入力してください';
// Step 11.0.0 END

export const I_RESET_COURSE_CONDITION_SUCCESS = (
  <span>
    処理結果については、完了後にトップの
    <Link to={TOP_LIST} style={{ fontWeight: 'bold', textDecoration: 'underline' }}>
      システムお知らせ一覧
    </Link>
    に表示されますので、そのお知らせの詳細から結果を確認してください
  </span>
);

export const E_SYSTEM_ERROR = 'システムエラーが発生しました';

export const ABOUT_PASSWORD_STRENGTH_TITLE = 'パスワード強度について';
export const ABOUT_PASSWORD_STRENGTH_BODY = (
  <div>
    <h3 className="text-center margin-bottom-10">パスワード強度について</h3>
    <div className="form-group">
      <div className="margin-left-10 col-sm-12 padding-left-right-15">
        <div className="col-sm-12 margin-bottom-10">
          <p>■標準</p>
        </div>
        <div className="margin-left-10 col-sm-12">
          <div className="col-sm-12 margin-bottom-10">
            <p>半角英数字記号（"\を除く）で４文字以上</p>
          </div>
        </div>
        <div className="col-sm-12 margin-bottom-10">
          <p>■中</p>
        </div>
        <div className="margin-left-10 col-sm-12">
          <div className="col-sm-12 margin-bottom-10">
            <p>半角英数字記号（"\を除く）で８文字以上</p>
          </div>
        </div>
        <div className="col-sm-12 margin-bottom-10">
          <p>■強</p>
        </div>
        <div className="margin-left-10 col-sm-12">
          <div className="col-sm-12">
            <p>半角の大英字、小英字、数字、記号（"\を除く）の組合せで１０文字以上</p>
            <br/>
            <div className="small">
              <p>また、パスワード強度が「強」の場合は以下の制限あり</p>
                 <ul className="margin-top-10">
                   <li className="margin-top-10">・３文字以上連続する文字列の使用を禁止（例：『aaa』『123』など）</li>
                   <li className="margin-top-10">・受講ユーザーのログインID内の文字列の使用を禁止</li>
                   <li className="margin-top-10">・２文字以上の単語の連続使用を禁止(例：『abab』など)</li>
                 </ul>
              <br/>
              <p>※管理ユーザーは設定に関わらず、常に「強」設定になります</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export const ABOUT_PASSWORD_BODY_FOR_STRONG_ONLY = (
  <div className="contianer">
    <h3 className="text-center margin-bottom-10">パスワードルール</h3>
    <div className="form-group">
      <div className="margin-left-10 col-sm-12">
        <div className="col-sm-12 margin-bottom-10">
          <p>■強</p>
        </div>
        <div className="margin-left-10 col-sm-12">
          <div className="col-sm-12">
            <p>半角の大英字、小英字、数字、記号（"\を除く）の組合せで１０文字以上</p>
            <br />
            <div className="small">
              <p>また、以下の制限あり</p>
              <ul className="margin-top-10">
                <li className="margin-bottom-10">・３文字以上連続する文字列の使用を禁止（例：『aaa』『123』など）</li>
                <li className="margin-bottom-10">・受講ユーザーのログインID内の文字列の使用を禁止</li>
                <li className="margin-bottom-10">・２文字以上の単語の連続使用を禁止(例：『abab』など)</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export const MSG_COLLECT_REPORT = 'レポートを強制回収してよろしいですか？';
export const MSG_APPROVAL_REPORT = 'レポートを承認してよろしいですか？';
export const MSG_FINISH_REPORT = '添削を完了しますがよろしいですか？(添削承認者の場合、添削承認はスキップとなり、自動で承認されます。)';
export const MSG_SAVE_REPORT = '添削中のレポートを一時保存して成績を更新しますがよろしいですか？';
// START #5611
export const MSG_REASON_REPORT = '差し戻し理由';
export const MSG_REMAND_REPORT = '差し戻し理由を入力してください';
export const MSG_REMAND_CONFIRM_REPORT = 'レポートを差し戻してよろしいですか？';
// END #5611
export const MSG_WITHDRAWAL_CONFIRM_REPORT = 'レポートの承認依頼を取り下げてよろしいですか？';

export const MSG_CONFIRM_BACK_PAGE = (
  <div>
    <p>保存をしない状態で一覧に戻ると、添削内容が破棄されてしまいますが、</p>
    <p>一覧に戻りますか？</p>
  </div>
);

export const MSG_ADD_VIDEO_SAME_TIME = '指定された再生時間のチャプターは既に登録されています';
export const MSG_EXCEED_VIDEO_PLAY_TIME = '再生時間を超えたチャプターは追加できません';
export const MSG_SEARCH_RESULT_NOT_MATCH = '検索条件に該当するものがありません';

export const MSG_RESULT_OVER_MAX_RETURN_NUM = '※1000件を超えるデータは表示できません。データが1000件を超える場合は、CSV一括投入をご利用ください';

export const MSG_CORRECT_ANSWER_WRONG_PATTERN = '利用できない文字（半角アンダースコア２つ「__」、半角スラッシュ「/」）が使われています。';

export const MSG_UPLOAD_SUCCESS = 'ビデオのアップロードに成功しました。 \n 変換されるまでしばらくお待ちください。';
export const MSG_UPLOAD_FAIL = 'ビデオのアップロードに失敗しました。\n（ビデオ）情報を削除し、登録をやりなおしてください。\n\nエラー内容 :';

// START #6487
export const MSG_UPLOAD_VIDEO_FAIL = '通信エラーが発生しました。';
// END #6487

export const EMAIL_TITLE_TEMPLATE = '{0}未完了の方へ';
export const EMAIL_BODY_TEMPLATE =
`お疲れさまです。
システムからのお知らせです。
本メールにはご返信できませんのでご了承ください。
お問い合わせがある方はシステム管理者にご連絡をお願いいたします。

{0}が完了していない方に、ご連絡いたします。
コース受講期限は〇〇月△△日までとなっておりますので、 
システムにログインの上、コースの実施をお願いいたします。`;

export const MSG_TRANSLATE_DEL_DOC = (
  <div>
    <p>登録済みのファイルを削除しますが</p>
    <p>よろしいですか？</p>
  </div>
);

// #7080 START
export const MSG_CONFIRM_INSERT_OPTION_SKIN = (
  <div>
    <p>オプションスキンの登録を行いますが</p>
    <p>よろしいですか？</p>
  </div>
);
// #7080 END

// #7303 START
export const MSG_USING_WRONG_CERTIFICATE = '不明なエラーが発生しました。指定された証明書が誤っている可能性があります';
// #7303 END
// Step SAML START
export const MSG_XML_UPLOAD_SIZE_INVALID = 'アップロードするファイルサイズの上限を超えています（上限：5MB）';
// Step SAML END

// Step 7.0 #3 START
export const MSG_USERFRONT_DISPLAY_SETTING_CONFIRM = (
  <div>
    <p>表示設定が保存されました。</p>
    <p>次に画像の設定をしてください。</p>
  </div>
);
// Step 7.0 #3 END

// sprint_20230522_tma START
export const W_REQUIRED_ITEM_LIST_START_CONDITION = '開始条件用のコンテンツが入力されていません';

export const MSG_ITEM_LIST_FOR_BOX_START_INVALID = '開始条件用のコンテンツが入力されていません';

export const MSG_CREDIT_CHECK_ENTERPRISE = (
  <div>
    <p>こちらの事業者は契約済みです。</p>
    <p>事業者対応を行ってから、利用停止状態に変更してください。</p>
  </div>
);
// sprint_20230522_tma END

// Step 10.0.0 START
export const MSG_DEL_SERVICE_GROUP = (
  <div>
    <p>対象のサービスグループを削除しますが</p>
    <p>よろしいですか？</p>
  </div>
);
// Step 10.0.0 END

// Step 9.0.1 START
export const MSG_SEND_ACCOUNT_INFO = (
  <div>
    <p>新しいパスワードをメールで送信します</p>
    <br/>
    <p className="textColorRed">メール送信のために、メールアドレスを入力してください。</p>
  </div>
);
// Step 9.0.1 END

// Step 10.0.0 START
export const MSG_DEL_SUPERUSER_SERVICE_ROLE = (
  <div>
    <p>対象のサービスロールを削除しますが</p>
    <p>よろしいですか？</p>
  </div>
);

export const MSG_DEL_SUPERUSER_ENTERPRISE_ROLE = (
  <div>
    <p>対象の企業ロールを削除しますが</p>
    <p>よろしいですか？</p>
  </div>
);

export const MSG_COURSE_PAGE_CONFIRM = (
  <div>
    <p>コース管理ページがリニューアルされました</p>
  </div>
);
// Step 10.0.0 END

// Step 11.0.1 TBD START
export const MSG_INFORMATION_GROUP = (
  <>
    <img
      style={{ height: '32px' }}
      src={IconInformation}
      alt="Information icon"
    />
    {/* STEP 12.0.0 TAS-18892 START */}
    <p style={{ lineHeight: '25px' }}>
      「全てのユーザーグループ」に対してアクセス権を持つ管理ユーザーのアクセス権を制限したい場合は、管理ユーザー管理より、サービス権限設定を「一部のユーザーグループ」へ変更する必要があります。
    </p>
    {/* STEP 12.0.0 TAS-18892 END */}
  </>
);
// Step 11.0.1 TBD END

// Step11.2.0 START
export const MSG_WARNING_LIVE = (
  <>
    <img
      style={{ height: '22px' }}
      src={IconWarning}
      alt="Warning icon"
    />
    <p style={{ lineHeight: '25px' }}>
      「ライブ機能」は2025年3月31日（月）をもってサービスの提供を終了いたします。2025年4月1日（火）以降の予約についてはライブの実施ができませんのでご了承願います。
    </p>
  </>
);
// Step11.2.0 END

// STEP12.0.0 TAS-18710 START
export const MSG_MANUAL_PASSWORD_SETTING_FLAG_TITLE = '免責事項確認';
export const MSG_MANUAL_PASSWORD_SETTING_FLAG_CONTENT = (
  <div className="margin-left-10">
    <p style={{ lineHeight: '25px' }}>パスワード手動変更機能を有効にすると、受講ユーザーならびに管理ユーザーの管理画面でパスワードを手動で変更できるようになります。</p>
    <p style={{ lineHeight: '25px' }}>また、次回ログイン時にパスワード変更を強制する機能も無効となります。</p>
    <br />
    <br />
    <p style={{ lineHeight: '25px' }}>この機能を有効化するとパスワード漏洩などのセキュリティリスクが高まります。</p>
    <p style={{ lineHeight: '25px' }}>この機能を有効化することで発生したセキュリティインシデントに起因する損害について、NTT東日本は一切の責任を負いません。</p>
    <p style={{ lineHeight: '25px' }}>同意いただける場合は「OK」をクリックし、機能を有効化してください。</p>
  </div>
);
// STEP12.0.0 TAS-18710 END
